// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_fK","advertDetailContactGroup__header":"c-m_fL","advertDetailContactGroup__value":"c-m_fM"};